import { QuanLyQuyHoachAction } from "./quanlyquyhoach.action-rule";
import { QuanLyQuyHoachActionType } from "./quanlyquyhoach.action-types";
import { TabIndex, TabIndexYKien } from './models/quanlyquyhoach.model';
import { File } from './models/luutruquyhoach.model';
import { FileResponse } from './api/luutruquyhoach.api';
export type LuuTru = {
  isShow: boolean,
  files: File[],
  fileSelected?: File,
  folderFree: File[],
  fileReponses?: Array<FileResponse>
};

export type PhuHopQuyHoach = {
  objectId?: number,
  dienTichDuAn?: number,
  dienTichSuDungDats?: Array<{ mucDichSuDung: string, dienTich: number,color:string }>,
  // color?: string | Array<number>
};

export type QuanLyQuyHoachModel = {
  phuHopQuyHoach: PhuHopQuyHoach,
  tabindex: TabIndex,
  tabindexYKien: TabIndexYKien,
  listDALYK: __esri.Graphic[],
  listDACB: __esri.Graphic[],
  listNDGYYK: Array<object>,


  listNDGYCB: Array<object>,
  luuTru: LuuTru,
  dataCount: number,
  dataCountGopY: number,
  list: __esri.Graphic[],
  listGopY: Array<object>
};

export const quanLyQuyHoachDefaultState: QuanLyQuyHoachModel = {
  phuHopQuyHoach: {
    objectId: 0,
    dienTichDuAn: 0,
    dienTichSuDungDats: [],
    // color: []

  },
  tabindex: TabIndex.LayYKien,
  tabindexYKien: TabIndexYKien.DanhSach,
  listDALYK: [],
  listDACB: [],
  listNDGYYK: [],
  listNDGYCB: [],
  luuTru: {
    isShow: false,
    files: [],
    fileSelected: { fileId: null, mimeType: 'folder', name: 'Thư mục chính', iconLink: '' },
    folderFree: [
      { fileId: null, mimeType: 'folder', name: 'Thư mục chính', iconLink: '' }
    ],
  },
  dataCount: 0,
  dataCountGopY: 0,
  list: [],
  listGopY: []
};

function reducer(state: QuanLyQuyHoachModel = quanLyQuyHoachDefaultState, action: QuanLyQuyHoachAction): QuanLyQuyHoachModel {
  switch (action.type) {
    case QuanLyQuyHoachActionType.QuanLyQuyHoach:
      return { ...state, tabindex: action.index };
    case QuanLyQuyHoachActionType.tabIndexYKien:
      return { ...state, tabindexYKien: action.indexYKien };
    case QuanLyQuyHoachActionType.GetListYKDA:
      return { ...state, listDALYK: action.listDAYK };
    case QuanLyQuyHoachActionType.GetListCBDA:
      return { ...state, listDACB: action.listDACB };
    case QuanLyQuyHoachActionType.GetListNDGopYYK:
      return { ...state, listNDGYYK: action.listNDGYYK };

    case QuanLyQuyHoachActionType.PhuHopQuyHoach_objectId:
      var phuHopQuyHoach = { ...state.phuHopQuyHoach };
      phuHopQuyHoach.objectId = action.objectId;
      return { ...state, phuHopQuyHoach };

    case QuanLyQuyHoachActionType.PhuHopQuyHoach_dienTichDuAn:
      return { ...state, phuHopQuyHoach: action.dienTichDuAn };

      // case QuanLyQuyHoachActionType.PhuHopQuyHoach_color:
      //   return { ...state, phuHopQuyHoach: action.color };


    case QuanLyQuyHoachActionType.GetListNDGopYCB:
      return { ...state, listNDGYCB: action.listNDGYCB };
    case QuanLyQuyHoachActionType.LuuTru_HienThi:
      var luuTru = { ...state.luuTru };
      luuTru.isShow = action.isShow;
      return { ...state, luuTru };
    case QuanLyQuyHoachActionType.LuuTru_SetFiles:
      var luuTru = { ...state.luuTru };
      luuTru.files = action.files;
      return { ...state, luuTru }
    case QuanLyQuyHoachActionType.LuuTru_ChonFile:
      var luuTru = { ...state.luuTru };

      // cap nhat lai cay thu muc neu la folder
      const file = action.file;
      if (file !== undefined) {
        if (file.mimeType === 'folder') {
          luuTru.fileSelected = action.file;
          let newFolderTree = [...state.luuTru.folderFree];
          var index = luuTru.folderFree.findIndex(f => f.fileId == file.fileId);
          // neu ton tai id trong cay thuc muc co nghia la chon lai thu muc cu
          if (index > -1) {
            // xoa nhung thu muc duoc chon phia sau
            newFolderTree.splice(index + 1, newFolderTree.length - index)
          }
          // neu khong ton tai id trong cay thu muc co nghia la chon thu muc moi
          else {
            newFolderTree.push(file);
          }
          luuTru.folderFree = newFolderTree;
        }
      } else {
        let newFolderTree = [...state.luuTru.folderFree];
        if (newFolderTree.length > 1)
          newFolderTree.splice(1, newFolderTree.length - 1);
        luuTru.folderFree = newFolderTree;
      }
      return { ...state, luuTru };
    case QuanLyQuyHoachActionType.LuuTru_SetFileResponses:
      var luuTru = { ...state.luuTru };
      luuTru.fileReponses = action.files;
      return { ...state, luuTru };
    case QuanLyQuyHoachActionType.GetDataCount:
      return { ...state, dataCount: action.dataCount };
    case QuanLyQuyHoachActionType.GetDataCountGopY:
      return { ...state, dataCountGopY: action.dataCountGopY };
    case QuanLyQuyHoachActionType.GetList:
      return { ...state, list: action.list };
    case QuanLyQuyHoachActionType.GetListGopY:
      return { ...state, listGopY: action.listGopY };
    default:
      return state;
  }
}

export default reducer;